export default __webpack_public_path__ + "static/logo-dark-144459d059bed214787a1ad5233af11c.svg";